import {createReducer} from '../utility'




export const fetchFile = createReducer({},{
    "FILE_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                file: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})